import { createSlice } from '@reduxjs/toolkit';
const initialState = {
  isMuted: false,
};

export const sliceSettings = createSlice({
  name: 'Settings',
  initialState,
  reducers: {
    setMuted(state, { payload: userData }) {
      state.isMuted = userData;
    },
  },
});

export const { setMuted } = sliceSettings.actions;
export default sliceSettings.reducer;
